import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';

@Component({
    selector: 'app-four-oh-three',
    templateUrl: './four-oh-three.component.html',
    styleUrls: ['./four-oh-three.component.scss'],
    standalone: false
})
export class FourOhThreeComponent implements OnInit {
  constructor(
    public globals: Globals,
  ) {}

  ngOnInit() {
  }
}
